import {Instagram} from "@mui/icons-material";
import tiktok_icon from "../assets/images/tiktok.svg";
import facebook_icon from "../assets/images/facebook.svg";

const useSocialMedia = () => {
    const socialMedia = [
        {
            label: "Facebook",
            icon: <img src={facebook_icon} alt="Facebook" width={24} height={24}/>,
            link: 'https://www.facebook.com/profile.php?id=61582898333229',
        },
        {
            label: "Instagram",
            icon: <Instagram color="primary"/>,
            link: 'https://www.instagram.com/genie.mk_'
        },
        {
            label: "TikTok",
            icon: <img src={tiktok_icon} alt="TikTok" width={24} height={24}/>,
            link: 'https://www.tiktok.com/@genie.mk'
        }
    ]

    return {socialMedia}
}

export default useSocialMedia